module.exports = __webpack_public_path__ + "img/suport-ti.49b20d4f.svg";